import { useMemo } from 'react';

import { useGetSelectorStringData } from 'hooks/useGetListData';

import { getListValue } from './List.utils';
import ListWrapper from './ListWrapper';

type Props = {
  item: any;
  send: any;
};

export default function StringList({ item, send }: Props) {
  const { data, error, status } = useGetSelectorStringData(item.FIELDEDITOR);

  const displayValue = useMemo(() => {
    const [id] = String(item.FIELDVALUE).split('|');
    return getListValue(data?.data, id);
  }, [data, item.FIELDVALUE]);

  const props = { item, send, data, error, displayValue };

  return <ListWrapper isLoading={status === 'loading'} {...props} />;
}
